import { createRequestActionTypes } from "../../../utility";

export const OrderCommentsActionTypes = {
  get_orderComments: createRequestActionTypes('GET_ORDER_COMMENTS'),
  add_orderComment: createRequestActionTypes('ADD_ORDER_COMMENT')
}